export default "__VITE_ASSET__CLge8OTx__"